import styled from 'styled-components';
import { BaseInput } from '#/shared/components/BaseCheckboxOrRadio/styled';

export const RadioButtonInput = styled(BaseInput)`
  border-radius: 100%;
`;

export const RadioSelected = styled.div`
  background-color: ${props => props.theme.toggleOptionCheckFill};
  border-radius: 100%;
  pointer-events: none;
  position: absolute;
  height: 10px;
  width: 10px;
  top: 6px;
  left: 6px;

  @media (forced-colors: active) {
    background-color: ButtonText;
  }
`;
